<router-outlet (activate)="isInitialized = true"></router-outlet>
<sh-main-loader *ngIf="!isInitialized"></sh-main-loader>
